import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AttachmentService } from '../../../attachment-view-feature/attachment.service';
import { IAttachment } from '../../../shared';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { IExpenseReceipt } from '../../IExpenseReceipt';
import * as fromExpense from '../../store/index';

@Component({
    selector: 'ef-expense-receipt-view-feature',
    templateUrl: './expense-receipt-view-feature.component.html',
    styleUrls: ['./expense-receipt-view-feature.component.scss'],
    standalone: false
})
export class ExpenseReceiptViewFeatureComponent implements OnInit, OnDestroy {
    public attachment$: Observable<Partial<IAttachment>>;
    public receipt$: Observable<IExpenseReceipt>;
    @Input() public receiptId: string;
    private active = true;
    constructor(
        private log: LoggingService,
        protected svc: AttachmentService,
        private expenseStore: Store<fromExpense.State>
    ) {
        this.log.verbose({ type: 'ExpenseReceiptViewFeatureComponent::' });
    }

    ngOnInit() {
        this.log.verbose({
            type: 'ExpenseReceiptViewFeatureComponent.ngOnInit',
            receiptId: this.receiptId
        });
        if (this.receiptId) {
            this.expenseStore.dispatch(
                new fromExpense.LoadExpenseReceiptAttachment({
                    File_unique_id: this.receiptId
                })
            );
        }
        this.attachment$ = this.expenseStore.pipe(
            select(fromExpense.getReceiptAttachment),
            tap(r =>
                this.log.verbose({
                    type: 'ExpenseReceiptViewFeatureComponent.attachment$',
                    receipt: r
                })
            ),
            map(r => ({ ...r }))
        );
    }
    ngOnDestroy(): void {
        this.active = false;
    }
}
